<template>
  <unicom-modal
    v-model="mostrar"
    :largura="452"
    fechar
    @input="valor => fecharModal(valor)"
  >
    <div slot="header">
      <div class="center iconeRedondo">
        <unicom-icone nome="alert-circle" :tamanho="66" class="iconStyle" />
      </div>
    </div>
    <div slot="body" class="modal-corpo fonte-secundaria">
      <p class="titulo negrito">{{ titulo }}</p>

      <div class="subtitulo fonte-secundaria">
        <div style="padding: 16px">
          <div style="line-height: 24px; max-height: 300px; overflow: auto">
            {{ Array.isArray(mensagemWarn) ? mensagemWarn[0] : mensagemWarn }}
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-corpo">
      <unicom-linha :espacamento="false" :justificarItem="'center'">
        <unicom-coluna :md="4">
          <unicom-botao
            tipo="importante"
            class="fonte-secundaria texto botaoFechar"
            :bloco="true"
            @click="$emit('fechar', false)"
            >DISPENSAR</unicom-botao
          >
        </unicom-coluna>
      </unicom-linha>
    </div>
  </unicom-modal>
</template>

<script>
import { icons } from "feather-icons";

const components = Object.values(icons).reduce(
  (prev, curr) => ({
    ...prev,
    [`icon-${curr.name}`]: {
      props: ["size"],
      render(createElement) {
        return createElement("div", {
          style: { display: "inline-block" },
          domProps: {
            innerHTML: curr.toSvg({ width: this.size, height: this.size })
          }
        });
      }
    }
  }),
  {}
);

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    titulo: {
      type: String,
      required: false,
      default: "Oops, algo deu errado."
    },
    mensagemWarn: {
      type: [String, Array],
      default: ""
    }
  },
  data() {
    return {
      iconStyle: {
        color: "$cor-primaria-1"
      },
      mostrar: this.value
    };
  },
  methods: {
    fecharModal(valor) {
      if (!valor) {
        this.$emit("fechar", false);
      }
    }
  },
  watch: {
    value() {
      this.mostrar = this.value;
    },
    mostrar() {
      this.$emit("input", this.mostrar);
    }
  },

  components
};
</script>

<style lang="scss" scoped>
@import "./ModalWarn";
</style>
